module.exports = __webpack_public_path__ + "static/media/M.1f0241ea.jpg";